import { cn } from "@/lib/chillnn/cn";

import { useCalender } from "../../context/calendar/calendar-context";
import { HeaderDayOfWeek, NextMonth, PresetOptions, PrevMonth, Table } from "../components";
import { useInitialize } from "./use-initialize";

export const Root = () => {
	const { selected, numberOfMonths, showPresetOptions } = useCalender();
	const { calendarData, onSetNextMonth, onSetPreviousMonth } = useInitialize({ selected, numberOfMonths });

	return (
		<div className="min-h-[418px] min-w-[340px] space-y-6 tablet:min-w-[390px]">
			<div
				className={cn(
					"relative grid gap-4", //
					numberOfMonths === 1 ? "grid-cols-1" : "grid-cols-2",
				)}
			>
				{/* 前月、次月ボタン */}
				<>
					<PrevMonth
						currentMonthFirstDay={calendarData.currentMonthFirstDay}
						onSetPreviousMonth={onSetPreviousMonth}
						className="absolute left-0 top-0"
					/>
					<NextMonth onSetNextMonth={onSetNextMonth} className="absolute right-0 top-0" />
				</>

				{/* カレンダーのテーブル */}
				{calendarData.daysOfMonth.map(({ month, days }, idx) => {
					return (
						<div key={idx} className="col-span-1 space-y-6">
							<h6 className="shrink-0 text-center text-lg font-medium tabular-nums">{month}</h6>

							<HeaderDayOfWeek dayOfWeekArray={calendarData.dayOfWeekArray} />
							<Table dateRangeArray={days} />
						</div>
					);
				})}
			</div>

			{/* プリセットオプション（日程の選択肢） */}
			{showPresetOptions && <PresetOptions />}
		</div>
	);
};
